var DashboardTicket = /** @class */ (function () {
    function DashboardTicket(props) {
        Object.assign(this, props);
    }
    return DashboardTicket;
}());
export { DashboardTicket };
export var Range = {
    Custom: 'custom',
    Today: 'day',
    Week: 'week',
    Month: 'month',
    Year: 'year'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/DashboardTicket/Model.ts
// module id = 1187
// module chunks = 0